module.exports = __webpack_public_path__ + "img/woman-emition-video.7dfbd21.png";